import * as React from 'react';
import { useDragLayer } from 'react-dnd';

const layerStyles: React.CSSProperties = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
};

function getItemStyles(currentOffset: { x: number; y: number } | null) {
    if (!currentOffset) return { display: 'none' } as React.CSSProperties;
    const x = currentOffset.x;
    const y = currentOffset.y;
    return {
        transform: `translate(${x}px, ${y}px)`,
        WebkitTransform: `translate(${x}px, ${y}px)`,
    } as React.CSSProperties;
}

export default function ModelDragLayer() {
    const { itemType, item, isDragging, currentOffset } = useDragLayer((monitor) => ({
        item: monitor.getItem(),
        itemType: monitor.getItemType(),
        isDragging: monitor.isDragging(),
        currentOffset: monitor.getClientOffset(),
    }));

    if (!isDragging || itemType !== 'ELEM' || !item) return null;

    const isFolder = item.type === 'FOLDER';
    const icon = isFolder ? 'folder' : 'architecture';
    const name = item.name || 'Untitled';

    return (
        <div style={layerStyles}>
            <div style={getItemStyles(currentOffset)}>
                <div className="flex items-center gap-2 px-3 py-2 bg-white border border-slate-200 rounded-lg shadow-lg max-w-[220px]">
                    <span className="material-symbols-outlined text-[20px] text-slate-500">{icon}</span>
                    <span className="text-sm font-medium text-slate-800 truncate">{name}</span>
                </div>
            </div>
        </div>
    );
}
